import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import { memo } from 'react';
import { Link } from 'react-router-dom';
import { CREDIT_PORTAL_URL, Span } from 'shared';
import logo from 'images/Alphaeon_Credit_Logo_Linear.png';
function WizardHeader() {
    return (_jsxs("div", { className: "wizard-header", children: [_jsx(Link, { to: CREDIT_PORTAL_URL, children: _jsx("img", { src: logo, className: "wizard-logo", alt: "Logo" }) }), _jsxs("div", { className: "wizard-header-title", children: [_jsx(LockOutlinedIcon, {}), _jsx(Span, { variant: "title-medium", bold: true, children: "Secure Application" })] })] }));
}
export default memo(WizardHeader);
